import { render, staticRenderFns } from "./order_products.vue?vue&type=template&id=faf38e50&scoped=true&"
import script from "./order_products.vue?vue&type=script&lang=js&"
export * from "./order_products.vue?vue&type=script&lang=js&"
import style0 from "./order_products.vue?vue&type=style&index=0&id=faf38e50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf38e50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('faf38e50')) {
      api.createRecord('faf38e50', component.options)
    } else {
      api.reload('faf38e50', component.options)
    }
    module.hot.accept("./order_products.vue?vue&type=template&id=faf38e50&scoped=true&", function () {
      api.rerender('faf38e50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/orders/order/tabs/order_products.vue"
export default component.exports